import React from 'react';
import { Banner, Button, ButtonClean, Icon, Subsection } from '@fourthwall/components';
import { SpotifyIcon } from '@fourthwall/icons';
import { routing } from '@utils/routing';
import * as S from './NoPostsFields.styled';
export const NoPostsFields = () => (React.createElement(Subsection, { title: "Add members-only audio to this podcast" },
    React.createElement(S.Container, null,
        React.createElement("div", null,
            "Allow members to listen to your audio posts on Spotify.",
            ' ',
            React.createElement(ButtonClean, { label: "Learn more", withUnderline: true, href: "https://help.fourthwall.com/hc/en-us/articles/31440397820059-How-to-Share-Members-Only-Audio-Content-on-Spotify", target: "_blank" })),
        React.createElement(Banner, { appearance: "warning", title: React.createElement(React.Fragment, null,
                "You don\u2019t have any audio posts created yet.",
                ' ',
                React.createElement(ButtonClean, { label: "Create a new post", to: `${routing.memberships.posts.create}?type=Audio` })) }),
        React.createElement(Button, { appearance: "secondary", leftIcon: React.createElement(Icon, { component: SpotifyIcon, height: 20 }), iconColor: "#1ed760", label: "Sync podcast to Spotify", disabled: true }))));
